module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns is-multiline"
  }, [_c('div', {
    staticClass: "column is-half"
  }, [_c('gallery-item', {
    attrs: {
      "mainurl": "static/gallery/csn-full.jpg",
      "mobileurl": "static/gallery/csn-mobile.jpg",
      "name": "Corporate Suites Network",
      "designer": "Visible",
      "n": "1"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-half"
  }, [_c('gallery-item', {
    attrs: {
      "mainurl": "static/gallery/reina-full.jpg",
      "mobileurl": "static/gallery/reina-mobile.jpg",
      "name": "Reina Imaging",
      "designer": "Zimmer-Design",
      "n": "2"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-half"
  }, [_c('gallery-item', {
    attrs: {
      "mainurl": "static/gallery/trifecta-full.jpg",
      "mobileurl": "static/gallery/trifecta-mobile.jpg",
      "name": "Trifecta Sauces",
      "designer": "Zimmer-Design",
      "n": "3"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-half"
  }, [_c('gallery-item', {
    attrs: {
      "mainurl": "static/gallery/wlf-full.jpg",
      "mobileurl": "static/gallery/wlf-mobile.jpg",
      "name": "West Liberty Foods",
      "designer": "CSSI",
      "n": "4"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-half"
  }, [_c('gallery-item', {
    attrs: {
      "mainurl": "static/gallery/azar-full.jpg",
      "mobileurl": "static/gallery/azar-mobile.jpg",
      "name": "Azar Nut Company",
      "designer": "CSSI",
      "n": "5"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-half"
  }, [_c('gallery-item', {
    attrs: {
      "mainurl": "static/gallery/iac-full.jpg",
      "mobileurl": "",
      "name": "IA Collaborative",
      "designer": "IA Collaborative",
      "n": "6"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-half"
  }, [_c('gallery-item', {
    attrs: {
      "mainurl": "static/gallery/bvf-full.jpg",
      "mobileurl": "static/gallery/bvf-mobile.jpg",
      "name": "Bay Valley Foods",
      "designer": "CSSI",
      "n": "7"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-half"
  }, [_c('gallery-item', {
    attrs: {
      "mainurl": "static/gallery/pug-full.jpg",
      "mobileurl": "",
      "name": "Pug Story",
      "designer": "Visible",
      "n": "8"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-half"
  }, [_c('gallery-item', {
    attrs: {
      "mainurl": "static/gallery/yc-full.jpg",
      "mobileurl": "",
      "name": "The Young Center",
      "designer": "EPIC",
      "n": "9"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-half"
  }, [_c('gallery-item', {
    attrs: {
      "mainurl": "static/gallery/red-full.jpg",
      "mobileurl": "static/gallery/red-mobile.jpg",
      "name": "Red Moby",
      "designer": "Visible",
      "n": "10"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7ee42e66!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Gallery.vue
// module id = 113
// module chunks = 2